import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shop/shop-icon.svg'
import _imports_1 from '@/assets/shop/shop-text.svg'


const _withScopeId = n => (_pushScopeId("data-v-2891cb10"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon",
      src: _imports_0
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon-text",
      src: _imports_1
    })
  ])
], -1))
const _hoisted_2 = { class: "best-seller-list" }
const _hoisted_3 = { class: "slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shop_card = _resolveComponent("shop-card")!
  const _component_common_section = _resolveComponent("common-section")!
  const _component_layout_footer = _resolveComponent("layout-footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "shop-container",
    style: _normalizeStyle(_ctx.cssProps)
  }, [
    _hoisted_1,
    _createVNode(_component_shop_card, {
      class: "trending-shop-card max-width",
      label: _ctx.t('shop.trending'),
      type: "highlighted",
      shop: _ctx.trendingShop
    }, null, 8, ["label", "shop"]),
    _createVNode(_component_common_section, {
      class: "c-section",
      colorLeft: _ctx.mainColor,
      colorRight: _ctx.secondaryColor,
      text: _ctx.t('shop.best-sellers')
    }, null, 8, ["colorLeft", "colorRight", "text"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bestSellersShop, (item) => {
        return (_openBlock(), _createBlock(_component_shop_card, {
          key: item.id,
          class: "detailed-shop-card",
          type: "detailed",
          shop: item
        }, null, 8, ["shop"]))
      }), 128))
    ]),
    _createVNode(_component_common_section, {
      class: "c-section",
      colorLeft: _ctx.mainColor,
      colorRight: _ctx.secondaryColor,
      text: _ctx.t('shop.staff-pick')
    }, null, 8, ["colorLeft", "colorRight", "text"]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffPickShop, (item) => {
        return (_openBlock(), _createBlock(_component_shop_card, {
          key: item.id,
          class: "slider-shop-card",
          type: "slider",
          shop: item
        }, null, 8, ["shop"]))
      }), 128))
    ]),
    _createVNode(_component_common_section, {
      class: "c-section",
      colorLeft: _ctx.mainColor,
      colorRight: _ctx.secondaryColor,
      text: _ctx.t('shop.mega-deal')
    }, null, 8, ["colorLeft", "colorRight", "text"]),
    _createVNode(_component_shop_card, {
      class: "mega-deal-shop-card",
      type: "detailed",
      shop: _ctx.megaDealShop
    }, null, 8, ["shop"]),
    (_ctx.pageReady)
      ? (_openBlock(), _createBlock(_component_layout_footer, {
          key: 0,
          spot: _ctx.adSpotFooter
        }, null, 8, ["spot"]))
      : _createCommentVNode("", true)
  ], 4))
}